import {CookieUtil} from '@mintdata-wsp/common/util/CookieUtil';
import {ApiError} from '@mintdata-wsp/common/controllers/network/Fetcher';
import {ApplicationContextController} from '@mintdata-wsp/common/controllers/context/ApplicationContextController';
import {API, fetcherSingleton} from '@mintdata-wsp/common/controllers/network/WorkspaceAPI';
import {User} from '@mintdata-wsp/common/state/DataState';
import {pubControllers} from '@mintdata-wsp/pub/controllers/PubControllers';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';

// note: TOKEN_COOKIE_NAME has to be the same as set in `publish.login.html`
const TOKEN_COOKIE_NAME = 'bdp_app_session_id';

const ANONYMOUS_USER_UUID = 'anonymous_user_uuid';

export class PubApplicationContextController implements ApplicationContextController
{
    async currentUser():Promise<User>
    {
        const authToken = CookieUtil.getCookie(TOKEN_COOKIE_NAME);
        if( authToken )
        {
            fetcherSingleton.setAuthToken(authToken);

            const response = await API.profile.get();
            if( !ApiError.isError(response) )
                return User.fromResponse(response);
        }

        return this._anonymousUser();
    }

    private _anonymousUser()
    {
        const storage = window.localStorage;
        let anonUuid = storage.getItem(ANONYMOUS_USER_UUID);
        if( !anonUuid )
        {
            anonUuid = IdUtil.newGUID();
            storage.setItem(ANONYMOUS_USER_UUID, anonUuid);
        }

        const anon = new User();
        anon.uuid = anonUuid;
        anon.fullName = 'Anonymous';

        return anon;
    }

    currentOrganizationSid():string
    {
        Assert.no(this.isStandaloneMode(), 'currentOrganizationSid should not be used in standaloneMode');
        return pubControllers.integration.organizationSid;
    }

    cacheScope():string
    {
        Assert.no(this.isStandaloneMode(), 'cacheScope should not be used in standaloneMode');
        return pubControllers.integration.publishedApplicationId.toString();
    }

    isStandaloneMode():boolean
    {
        return pubControllers.integration.isStandaloneMode;
    }
}
